<template>
    <div class="content_center">
        <img class="d-flex justify-center mx-auto" src="/Sucess.png" />
        <div class="d-flex justify-center mt-2 message-font-size">We couldn’t process the payment.</div>
        <div class="d-flex justify-center mt-3 ">  
            <q-btn class="pd-btn" @click="openCartPage">GO BACK TO CART</q-btn>  
        </div>
      
    </div>
</template>

<script>
export default{
data(){
    return{
        orderId:123456
    }
},
methods:{
    openCartPage(){
        this.$router.push(`/Partners/Stock/Cart`)
    }
}
}

</script>

<style>

.message-font-size{
    font-size: large;
}

.color-set{
    background-color: #167E85;
    color: aliceblue
}

.content_center{
    position: absolute;
    top: 48%;
    left: 48%;
    transform: translate(-48%, -50%);
    padding-bottom: 0 !important;
    
}
/* .img-set{
margin-top: 200px;
margin-left: 860px;

}

.font-set{
text-align: center;
font-weight: 900;
font-size: x-large;
color: black;
}

.font-size{
text-align: center;
font-weight: 800;
font-size: large;
color: black;
margin-top: 15px;
}

.btn-set{
background: #115A92;
color: white;
margin-left: 840px;
margin-top: 15px;
} */

/* .background-container{
background-color: #E7EFF2;
min-height: 100vh
} */

</style>